export const GET_STYLINGUSER_CALENDAR_SUCCESS = 'GET_STYLINGUSER_CALENDAR_SUCCESS';
export const GET_STYLINGUSER_MULTIPLE_CALENDARS_SUCCESS =
    'GET_STYLINGUSER_MULTIPLE_CALENDARS_SUCCESS';
export const UPDATE_STYLINGUSER_CALENDAR_SUCCESS = 'UPDATE_STYLINGUSER_CALENDAR_SUCCESS';
export const GET_STYLINGUSER_EVENTS_SUCCESS = 'GET_STYLINGUSER_EVENTS_SUCCESS';
export const GET_STYLINGUSER_CALENDAR_PRINT_EVENTS_SUCCESS =
    'GET_STYLINGUSER_CALENDAR_PRINT_EVENTS_SUCCESS';

export const CREATE_STYLINGUSER_CALENDAR_ITEM_SUCCESS = 'CREATE_STYLINGUSER_CALENDAR_ITEM_SUCCESS';
export const DELETE_STYLINGUSER_CALENDAR_ITEM_SUCCESS = 'DELETE_STYLINGUSER_CALENDAR_ITEM_SUCCESS';
export const UPDATE_STYLINGUSER_CALENDAR_ITEM_SUCCESS = 'UPDATE_STYLINGUSER_CALENDAR_ITEM_SUCCESS';
